import { NativeSelectField, NativeSelectRoot } from '@web/components/chakra-ui/native-select'
import type { NativeSelectFieldProps, NativeSelectRootProps } from '@chakra-ui/react/native-select'
import { Field } from '../Field'
import React from 'react'
import { FieldProps } from '@web/components/chakra-ui/field'

const Select = React.forwardRef<
  HTMLSelectElement,
  NativeSelectFieldProps & { fieldProps?: FieldProps; rootProps?: NativeSelectRootProps }
>(({ fieldProps, rootProps, ...rest }, ref) => {
  return (
    <Field {...fieldProps} htmlFor={rest.id}>
      <NativeSelectRoot {...rootProps}>
        <NativeSelectField {...rest} ref={ref} bgColor="ge.white" />
      </NativeSelectRoot>
    </Field>
  )
})

export default Select
